import type { TFunction } from "i18next";
import type { WorkflowInputSummary } from "../../../../api/content/workflowsApi";
import { namesText } from "../../stepPlans/planText";

/**
 * What a Workflow takes to start, on its card (F28, F123): each input by its human label,
 * an optional one marked; `null` for a Workflow that takes nothing.
 */
export function workflowInputsText(inputs: readonly WorkflowInputSummary[], t: TFunction): string | null {
  if (inputs.length === 0) return null;
  const named = inputs.map((input) =>
    t(input.required ? "threads.prepare.run.input" : "threads.prepare.run.optionalInput", { label: input.label }),
  );
  return t("threads.prepare.run.takes", { inputs: namesText(named, t) });
}
